import React, { useEffect, useState } from "react";
import { Layout } from "antd";
import PropTypes from "prop-types";
import ContentSider from "../../components/templates/ContentSider";
import Surface from "../../components/layouts/Surface";
import Spacer from "../../components/layouts/Spacer";
import SubMenu from "../../components/templates/SubMenu";
import { AuditOutlined } from "@ant-design/icons";
import Ok2GoTable from "./Ok2GoTable";
import Interfaces from "./Interfaces";
import { useDispatch } from "react-redux";
import {
  setApi,
  setActiveSection,
  setActiveEntity,
  reset,
  resetPage,
} from "./ok2GoSlice";
import { useSelector } from "react-redux";
import { usePermission } from "../../hooks/accessControl";

const { Content } = Layout;

const Ok2GoRevaha = (props) => {
  const [menuKey, setMenuKey] = useState("ok2Go_employees");
  const dispatch = useDispatch();
  const { activeBranch } = useSelector((state) => state.ok2Go);
  useEffect(() => {
    dispatch(setApi("revaha"));
    dispatch(setActiveEntity("employee_id"));
    dispatch(setActiveSection("employees"));
    return () => {
      dispatch(reset());
    };
  }, []);

  const onMenuSelect = ({ key }) => {
    const item = items.find((i) => i.name === key);
    if (item?.api) {
      const { section, entity } = item;
      dispatch(setActiveEntity(entity));
      dispatch(setActiveSection(section));
      dispatch(resetPage());
      setMenuKey(key);
    } else if (item) {
      setMenuKey(key);
    }
  };

  const hasEditorPermission = usePermission(
    activeBranch,
    "ok2go_revaha",
    "editor"
  );
  const items = [
    {
      name: "ok2Go_employees",
      section: "employees",
      entity: "employee_id",
      category: "settings",
      icon: <AuditOutlined />,
      api: "revaha",
    },
    // {
    //   name: "ok2Go_troms",
    //   section: "troms",
    //   entity: "order_id",
    //   category: "settings",
    //   icon: <AuditOutlined />,
    //   api: "revaha",
    // },
    {
      name: "ok2Go_schedules",
      section: "schedules",
      entity: "patient_id",
      category: "settings",
      icon: <AuditOutlined />,
      api: "revaha",
    },
    ...(hasEditorPermission
      ? [
          {
            name: "ok2Go_interfaces",
            section: "interfaces",
            entity: "",
            category: "settings",
            icon: <AuditOutlined />,
            api: null,
          },
        ]
      : []),
  ];
  const selectedItem = items.find((item) => item.name === menuKey);

  return (
    <Layout style={{ background: "transparent", height: "100%" }}>
      <Spacer horizontal={true} />
      <ContentSider width={250}>
        <SubMenu
          onMenuSelect={onMenuSelect}
          items={items}
          selectedKeys={[menuKey]}
        />
      </ContentSider>
      {selectedItem?.api && (
        <Content style={{ minHeight: 280, flex: 1 }}>
          <Surface style={{ paddingTop: "10px" }}>
            {<Ok2GoTable showEmployeesSelect showClientsSelect type="revaha" />}
          </Surface>
        </Content>
      )}

      {selectedItem?.name === "ok2Go_interfaces" && <Interfaces />}
    </Layout>
  );
};

Ok2GoRevaha.propTypes = {
  mode: PropTypes.string,
};

export default Ok2GoRevaha;
